/*
 *      ev12_aedp.js
 *          Script de ev12_aedp.vue          
 */
/* ======================================================================================================== */
import moment from 'moment'
import ingreso from './ingreso.vue'

import Vue from 'vue';

import jsPDF from 'jspdf'
Vue.use(jsPDF)

import { store } from './../store/store'

// import 'materialize-css/dist/css/materialize.min.css'
import M from 'materialize-css'

export default {
     name: 'formaaedp',
     components: {
          'moment': moment,
          'input-date': ingreso,
     },
     template: `#formaaedp`,
     data() {
          return {
               activo: true,  //! BORRAR ?


               activo1:"active", activo2: '!active', activo3: "!active",
               ver1: true, ver2: false, ver3: false,
               prueba: "", prueba2: '', prueba3: '',

               ejemplo: {},
               eval_aedp: {}, res: {},
               modo: "",
               eval_fecha: new Date(),
               instrucciones: "",
               inicioeval: false, finalizoeval: false, grabado: false,
               pregSinContestar: 0, ejeSinResponder: 0,
               totalPreguntas: 0,
               grupo1: true,
               grupo2: false,

               //? .....................................................................................................................................................................................................................
               activott1:"active", activott2: '!active', activott3: "!active", activott4:"!active", activott5: '!active', 
               activott6: "!active", activott7:"!active", activott8: '!active', activott9: "!active", activott10: "!active",  
               vertt1: true, vertt2: false, vertt3: false, vertt4: false, vertt5: false, 
               vertt6: false, vertt7: false, vertt8: false, vertt9: false, vertt10: false,
               area1: "", area2: '', area3: '', area4: "", area5: '', area6: '',  area7: "", area8: '', area9: '',  area10: '',

               //? .....................................................................................................................................................................................................................
               activott11:"active", activott12: '!active', activott13: "!active", activott14:"!active", activott15: '!active', 
               activott16: "!active", activott17:"!active", activott18: '!active', activott19: "!active", activott20: "!active",
               activott21: "!active", 
               vertt11: true, vertt12: false, vertt13: false, vertt14: false, vertt15: false, 
               vertt16: false, vertt17: false, vertt18: false, vertt19: false, vertt20: false,
               vertt21: false,
               area11: "", area12: '', area13: '', area14: "", area15: '', area16: '',  area17: "", area18: '', area19: '',  
               area20: '', area21: '',

          } // return
     }, // data()
     mounted() {

          /** Definiciones para el uso de los slides y tooltips */
          var elems = document.querySelectorAll('.collapsible');
          var instances = M.Collapsible.init(elems, {});

          var elems = document.querySelectorAll('.tooltipped');
          var instances = M.Tooltip.init(elems, {});

          var elem = document.querySelectorAll('.tabs');
          var instances = M.Tabs.init(elem, {});

          this.limpiarEvaluacion();

          /** obtiene localmente el caso definido en el almacén (store) */
          this.cargaEvaluacion();

          this.totalPreguntas= this.sinContestar();

          document.getElementById("grupo1").disabled = this.grupo1;
          document.getElementById("grupo2").disabled = this.grupo2;
     },
     computed: {
          l_sinResponder() {
               return this.sinContestar();
          },
          l_ejeSinResponder() {
               return this.ejeSinContestar();
          },
     },
     methods: {
          grabarEvaluacion(){
               if (this.pregSinContestar>0){
                    alert("Aún hay preguntas sin responder !");
               }
          },
          areas1_10(){
               this.grupo1= true;
               this.grupo2= false;
               document.getElementById("grupo1").disabled = this.grupo1;
               document.getElementById("grupo2").disabled = this.grupo2;
          },
          areas11_21(){
               this.grupo1= false;
               this.grupo2= true;
               document.getElementById("grupo1").disabled = this.grupo1;
               document.getElementById("grupo2").disabled = this.grupo2;
          },
          //* ----------------------------------------------------------------------
          crearPDF() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_aedp.nombre,
                    patron = / /g,
                    nuevoValor = "",
                    nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "aedp_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new jsPDF('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1);                    // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación de SUPERVISION para " + this.eval_aedp.nombre + " de " + this.eval_aedp.empresa + " ( " + this.eval_aedp.depto + " )");

               this.respuestas(doc);
               this.resultados(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
               resultados(doc) {

                    this.res_aedp= {
                         hs: 0, cd: 0, ce: 0, hr: 0, sc: 0,
                         aciertos: 0,
                         percentilHS: 0, rangoHS: "",
                    };

                    this.rangosaedp();

                    doc.setLineWidth(0.25);

                    doc.text(10, 88, "SECCION DE RESULTADOS ")
                    doc.line(10, 89, 206, 89);

                    let aciertos = this.res_aedp.aciertos;
                    let rangosHS = this.res_aedp.rangosHS;
                    let hs = this.res_aedp.hs;
                    let cd = this.res_aedp.cd;
                    let ce = this.res_aedp.ce;
                    let hr = this.res_aedp.hr;
                    let sc = this.res_aedp.sc;

                    doc.text(20, 94, "Pc."); doc.text(30, 94, "RESULTADOS"); doc.text(63, 94, "RANGO");
                    doc.text(20, 96, "-------"); doc.text(30, 96, "--------------------"); doc.text(60, 96, "-------------------");
                    doc.text(10, 100, "[HS]");
                    doc.text(22, 100, hs.toString()); doc.text(35, 100, aciertos.toString()); doc.text(62, 100, rangosHS);

                    doc.text(10, 105, "[CD]");
                    doc.text(22, 105, cd.toString()); 

                    doc.text(10, 110, "[CE]");
                    doc.text(22, 110, ce.toString()); 

                    doc.text(10, 115, "[HR]");
                    doc.text(22, 115, hr.toString()); 

                    doc.text(10, 120, "[SC]");
                    doc.text(22, 120, sc.toString());  
                    doc.text(20, 122, "-------"); doc.text(30, 122, "--------------------"); doc.text(60, 122, "-------------------");
                    let desaciertos= 30 - aciertos;
                    doc.text(10, 127,"Aciertos ? ");
                    doc.text(25, 127, aciertos.toString());
                    doc.text(32, 127, "No Aciertos ? ");
                    doc.text(52, 127, desaciertos.toString());
               },
               respuestas(doc) {
                    /* Muestra las preguntas */
                    /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
                    doc.setLineWidth(0.25);

                    doc.text(10, 40, "SECCION DE RESPUESTAS ")
                    doc.line(10, 42, 190, 42);
                    doc.text(10, 45, "01= "); doc.text(23, 45, this.eval_aedp.pg001); doc.text(30, 45, "02= "); doc.text(43, 45, this.eval_aedp.pg002);
                    doc.text(50, 45, "03= "); doc.text(63, 45, this.eval_aedp.pg003); doc.text(70, 45, "04= "); doc.text(83, 45, this.eval_aedp.pg004);
                    doc.text(90, 45, "05= "); doc.text(103, 45, this.eval_aedp.pg005); doc.text(110, 45, "06= "); doc.text(123, 45, this.eval_aedp.pg006);
                    doc.text(130, 45, "07= "); doc.text(143, 45, this.eval_aedp.pg007); doc.text(150, 45, "08= "); doc.text(163, 45, this.eval_aedp.pg008);
                    doc.text(170, 45, "09= "); doc.text(183, 45, this.eval_aedp.pg009);
                    doc.line(10, 46, 190, 46);
                    doc.text(10, 49, "10= "); doc.text(23, 49, this.eval_aedp.pg010); doc.text(30, 49, "11= "); doc.text(43, 49, this.eval_aedp.pg011);
                    doc.text(50, 49, "12= "); doc.text(63, 49, this.eval_aedp.pg012); doc.text(70, 49, "13= "); doc.text(83, 49, this.eval_aedp.pg013);
                    doc.text(90, 49, "14= "); doc.text(103, 49, this.eval_aedp.pg014); doc.text(110, 49, "15= "); doc.text(123, 49, this.eval_aedp.pg015);
                    doc.text(130, 49, "16= "); doc.text(143, 49, this.eval_aedp.pg016); doc.text(150, 49, "17= "); doc.text(163, 49, this.eval_aedp.pg017);
                    doc.text(170, 49, "18= "); doc.text(183, 49, this.eval_aedp.pg018);
                    doc.line(10, 50, 190, 50);
                    doc.text(10, 53, "19= "); doc.text(23, 53, this.eval_aedp.pg019); doc.text(30, 53, "20= "); doc.text(43, 53, this.eval_aedp.pg020);
                    doc.text(50, 53, "21= "); doc.text(63, 53, this.eval_aedp.pg021); doc.text(70, 53, "22= "); doc.text(83, 53, this.eval_aedp.pg022);
                    doc.text(90, 53, "23= "); doc.text(103, 53, this.eval_aedp.pg023); doc.text(110, 53, "24= "); doc.text(123, 53, this.eval_aedp.pg024);
                    doc.text(130, 53, "25= "); doc.text(143, 53, this.eval_aedp.pg025); doc.text(150, 53, "26= "); doc.text(163, 53, this.eval_aedp.pg026);
                    doc.text(170, 53, "27= "); doc.text(183, 53, this.eval_aedp.pg027);
                    doc.line(10, 54, 190, 54);
                    doc.text(10, 57, "28= "); doc.text(23, 57, this.eval_aedp.pg028); doc.text(30, 57, "29= "); doc.text(43, 57, this.eval_aedp.pg029);
                    doc.text(50, 57, "30= "); doc.text(63, 57, this.eval_aedp.pg030);
                    doc.line(10, 59, 65, 59);
               },
                    rangosaedp() {

                         /* ================================================================================= */
                         /* Conteo para HR */
                         if (this.eval_aedp.pg001 === "c") {
                              this.res_aedp.hr = this.res_aedp.hr + 1;
                         }
                         if (this.eval_aedp.pg010 === "c") {
                              this.res_aedp.hr = this.res_aedp.hr + 1;
                         }
                         if (this.eval_aedp.pg011 === "a") {
                              this.res_aedp.hr = this.res_aedp.hr + 1;
                         }
                         if (this.eval_aedp.pg013 === "d") {
                              this.res_aedp.hr = this.res_aedp.hr + 1;
                         }
                         if (this.eval_aedp.pg025 === "b") {
                              this.res_aedp.hr = this.res_aedp.hr + 1;
                         }
          
                         /* ================================================================================= */
                         /* Conteo para HS */
                         if (this.eval_aedp.pg002 === "b") {                     this.res_aedp.hs = this.res_aedp.hs + 1;                }
                         if (this.eval_aedp.pg003 === "d") {                     this.res_aedp.hs = this.res_aedp.hs + 1;                }
                         if (this.eval_aedp.pg016 === "d") {                     this.res_aedp.hs = this.res_aedp.hs + 1;                }
                         if (this.eval_aedp.pg018 === "d") {                     this.res_aedp.hs = this.res_aedp.hs + 1;                }
                         if (this.eval_aedp.pg024 === "d") {                     this.res_aedp.hs = this.res_aedp.hs + 1;                }
                         if (this.eval_aedp.pg030 === "a") {                     this.res_aedp.hs = this.res_aedp.hs + 1;                }
          
                         /* ================================================================================= */
                         /* Conteo para CD */
                         if (this.eval_aedp.pg004 === "b") {                     this.res_aedp.cd = this.res_aedp.cd + 1;                }
                         if (this.eval_aedp.pg006 === "b") {                     this.res_aedp.cd = this.res_aedp.cd + 1;                }
                         if (this.eval_aedp.pg020 === "b") {                     this.res_aedp.cd = this.res_aedp.cd + 1;                }
                         if (this.eval_aedp.pg023 === "a") {                     this.res_aedp.cd = this.res_aedp.cd + 1;                }
                         if (this.eval_aedp.pg029 === "c") {                     this.res_aedp.cd = this.res_aedp.cd + 1;                }
          
                         /* ================================================================================= */
                         /* Conteo para SC */
                         if (this.eval_aedp.pg005 === "b") {                     this.res_aedp.sc = this.res_aedp.sc + 1;                }
                         if (this.eval_aedp.pg008 === "b") {                     this.res_aedp.sc = this.res_aedp.sc + 1;                }
                         if (this.eval_aedp.pg015 === "d") {                     this.res_aedp.sc = this.res_aedp.sc + 1;                }
                         if (this.eval_aedp.pg017 === "b") {                     this.res_aedp.sc = this.res_aedp.sc + 1;                }
                         if (this.eval_aedp.pg022 === "a") {                     this.res_aedp.sc = this.res_aedp.sc + 1;                }
                         if (this.eval_aedp.pg028 === "c") {                     this.res_aedp.sc = this.res_aedp.sc + 1;                }
          
                         /* ================================================================================= */
                         /* Conteo para CE */
                         if (this.eval_aedp.pg007 === "b") {                     this.res_aedp.ce = this.res_aedp.ce + 1;                }
                         if (this.eval_aedp.pg009 === "c") {                     this.res_aedp.ce = this.res_aedp.ce + 1;                }
                         if (this.eval_aedp.pg012 === "c") {                     this.res_aedp.ce = this.res_aedp.ce + 1;                }
                         if (this.eval_aedp.pg014 === "d") {                     this.res_aedp.ce = this.res_aedp.ce + 1;                }
                         if (this.eval_aedp.pg019 === "c") {                     this.res_aedp.ce = this.res_aedp.ce + 1;                }
                         if (this.eval_aedp.pg021 === "a") {                     this.res_aedp.ce = this.res_aedp.ce + 1;                }
                         if (this.eval_aedp.pg026 === "c") {                     this.res_aedp.ce = this.res_aedp.ce + 1;                }
                         if (this.eval_aedp.pg027 === "a") {                     this.res_aedp.ce = this.res_aedp.ce + 1;                }
                         /* ================================================================================= */
          
                         /* ================================================================================= */
                         /* Conteo de todos los aciertos */
                         this.res_aedp.aciertos = 0;
                         this.res_aedp.aciertos = this.res_aedp.hs + this.res_aedp.cd + this.res_aedp.ce + this.res_aedp.hr + this.res_aedp.sc;
          
                         /* Busca el rango que le corresponde */
                         this.res_aedp.rangosHS = '';
                         let comp1 = (this.res_aedp.aciertos >= 0 && this.res_aedp.aciertos <= 8); if (comp1 === true) { this.res_aedp.rangosHS = 'INFERIOR'; }
                         let comp2 = (this.res_aedp.aciertos >= 9 && this.res_aedp.aciertos <= 11); if (comp2 === true) { this.res_aedp.rangosHS = 'POBRE'; }
                         let comp3 = (this.res_aedp.aciertos >= 12 && this.res_aedp.aciertos <= 18); if (comp3 === true) { this.res_aedp.rangosHS = 'MEDIO'; }
                         let comp4 = (this.res_aedp.aciertos >= 19 && this.res_aedp.aciertos <= 23); if (comp4 === true) { this.res_aedp.rangosHS = 'BUENO'; }
                         let comp5 = (this.res_aedp.aciertos >= 24 && this.res_aedp.aciertos <= 30); if (comp5 === true) { this.res_aedp.rangosHS = 'SUPERIOR'; }
          
                    }, // rangos()
          //* ----------------------------------------------------------------------

          ejeSinContestar: function () {

               this.ejeSinResponder = 0;
               console.log("1 ? ", this.ejemplo.pg001);
               if (this.ejemplo.pg001 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }
               if (this.ejemplo.pg002 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }
               if (this.ejemplo.pg003 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }
               if (this.ejemplo.pg004 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }
               if (this.ejemplo.pg005 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }

               return this.ejeSinResponder;
          },
          sinContestar: function () {

               this.pregSinContestar = 0;

               //? ÁREA 1
               if (this.eval_aedp.pg001 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg002 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg003 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg004 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg005 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg006 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg007 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg008 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg009 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg010 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg011 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg012 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg013 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg014 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg015 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg016 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg017 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg018 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 2
               if (this.eval_aedp.pg019 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg020 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg021 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg022 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg023 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg024 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg025 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg026 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg027 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg028 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg029 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg030 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg031 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg032 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg033 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg034 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg035 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 3
               if (this.eval_aedp.pg036 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg037 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg038 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg039 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg040 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg041 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg042 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg043 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg044 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg045 === "") { this.pregSinContestar = this.pregSinContestar + 1; }               
               if (this.eval_aedp.pg046 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg047 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg048 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg049 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 4
               if (this.eval_aedp.pg050 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg051 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg052 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg053 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg054 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg055 === "") { this.pregSinContestar = this.pregSinContestar + 1; }               
               if (this.eval_aedp.pg056 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg057 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg058 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg059 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg060 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 5
               if (this.eval_aedp.pg061 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg062 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg063 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg064 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg065 === "") { this.pregSinContestar = this.pregSinContestar + 1; }               
               if (this.eval_aedp.pg066 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg067 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg068 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg069 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 6
               if (this.eval_aedp.pg070 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg071 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg072 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg073 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg074 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg074b === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg074c === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg074d === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg074e === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg074f === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg074g === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg074h === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg074i === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               
               //? ÁREA 7
               if (this.eval_aedp.pg075 === "") { this.pregSinContestar = this.pregSinContestar + 1; }               
               if (this.eval_aedp.pg076 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg077 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg078 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg079 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg080 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg081 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg082 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg083 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg084 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg085 === "") { this.pregSinContestar = this.pregSinContestar + 1; }               
               if (this.eval_aedp.pg086 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg087 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg088 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 8
               if (this.eval_aedp.pg089 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg090 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg091 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg092 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg093 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg094 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg095 === "") { this.pregSinContestar = this.pregSinContestar + 1; }               
               if (this.eval_aedp.pg096 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg097 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg098 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 9
               if (this.eval_aedp.pg099 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg100 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg101 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg102 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg103 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg104 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg105 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg106 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg107 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg108 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg109 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg110 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg111 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 10
               if (this.eval_aedp.pg112 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg113 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg114 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg115 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg116 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg117 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg118 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg119 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg120 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg121 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 11
               if (this.eval_aedp.pg122 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg123 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg124 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg125 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg126 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg127 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg128 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg129 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg130 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg131 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg132 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg133 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg134 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 12
               if (this.eval_aedp.pg135 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg136 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg137 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg138 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg139 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg140 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg141 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg142 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg143 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg144 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg145 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg146 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 13
               if (this.eval_aedp.pg147 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg148 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg149 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg150 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg151 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg152 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg153 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg154 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 14
               if (this.eval_aedp.pg155 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg156 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg157 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg158 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg159 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg160 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg161 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg162 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg163 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg164 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg165 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 15
               if (this.eval_aedp.pg166 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg167 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg168 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg169 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg170 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg171 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg172 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg173 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg174 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg175 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 16
               if (this.eval_aedp.pg176 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg177 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg178 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg179 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg180 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg181 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg182 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg183 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg184 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg185 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg186 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg187 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg188 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 17
               if (this.eval_aedp.pg189 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg190 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg191 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg192 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg193 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg194 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg195 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg196 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg197 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 18
               if (this.eval_aedp.pg198 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg199 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg200 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg201 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg202 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg203 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg204 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg205 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg206 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg207 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg208 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg209 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg210 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg211 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg212 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg213 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg214 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg215 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg216 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg217 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg218 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg219 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg220 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg221 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg222 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg223 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg224 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg225 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg226 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg227 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg228 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg229 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 19
               if (this.eval_aedp.pg230 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg231 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg232 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg233 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg234 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg235 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg236 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg237 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg238 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg239 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg240 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg241 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 20
               if (this.eval_aedp.pg242 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg243 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg244 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg245 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg246 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg247 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg248 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               //? ÁREA 21
               if (this.eval_aedp.pg249 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg250 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg251 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg252 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg253 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_aedp.pg254 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               return this.pregSinContestar;
          },


          addADayToMyDate() {
               if (this.eval_fecha) // as myDate can be null
                    // you have to set the this.myDate again, so vue can detect it changed
                    // this is not a caveat of this specific solution, but of any binding of dates
                    this.eval_aedp.empezo = new Date(this.eval_fecha.setDate(this.eval_fecha.getDate() + 1));
          },
          dateToYYYYMMDD(date) {
               console.log("***********************************************************************************");
               console.log("Estoy en dateToYYYYMMDD ");
               console.log("date ? ", date, "; typeof ", typeof (date));
               console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
               console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

               console.log("Desmenuzando ...");
               var a = date.toISOString();
               var b = a.split("T");
               var c = b[0];
               var d = b[1];
               console.log("a) date.toISOString() ", date.toISOString());
               console.log("b) ", a.split("T"));
               console.log("c) b[0]", b[0], "; b[1] ", b[1]);
               console.log("***********************************************************************************");

               // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
               return date && date.toISOString().split('T')[0]
          },

               cargaHora() {

                    // Convierte la hora obtenida a hora local (utc)
                    this.eval_fecha = new Date();
                    var d = this.eval_fecha;
                    var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(),
                         d.getMinutes(), d.getSeconds(), d.getMilliseconds());

                    // obtain local UTC offset and convert to msec
                    let localOffset = d.getTimezoneOffset() * 60000;
                    var newdate = new Date(utcd + localOffset);
                    var hours = newdate.getHours();
                    var minutes = newdate.getMinutes();
                    var seconds = newdate.getSeconds();
                    var hora = hours + ":" + minutes + ":" + seconds;
                    console.log("newdate ? ", newdate, " | ", hora);

                    return hora;
               },
          cargaEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0,
               };

               this.eval_aedp = store.state.st_ev12;        // Crea el nodo para todos los campos.
               this.res_aedp = store.state.st_rs12;
               console.log("res ? ", this.res_16pf);

               this.eval_aedp.nombre = store.state.st_nusuario;    // Nombre del usuario que hará la evaluación
               this.eval_aedp.empresa = store.state.st_empresa;     // Nombre de la empresa a la cual pertenece el usuario
               this.eval_aedp.depto = store.state.st_depto;     // Nombre de la empresa a la cual pertenece el usuario
               this.eval_aedp.sexo = store.state.st_sexo;     // Nombre de la empresa a la cual pertenece el usuario

               this.instrucciones = this.eval_aedp.nombre.toUpperCase() + " haga click aqui para leer las instrucciones para responder la evaluación de AUTO EXPLORACIÓN EMOCIONAL PARA EL DESARROLLO PERSONAL."

               this.eval_fecha = new Date();                 // Fecha del Día
          },
          empezarEvaluacion() {

               this.eval_aedp.empezo = this.cargaHora();
               this.inicioeval = true;

               this.limpiarEvaluacion2();

          },
          /** .................... VALIDACIONES  .................... */
          validarValor(valor) {
               let lvalor = valor;
               if (valor < 0 || valor > 3) {
                    lvalor = 0;
               }
               // console.log("validarValor, lvalor ? ",lvalor);
               return lvalor;
          },
          limpiarEvaluacion() {


               console.log("LIMPIANDO EVALUACIÓN !!!");

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0,
               };

               this.eval_aedp = {
                    depto: "Guatemala",
                    empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
                    fecha: "16/01/2019", sexo: "",
                    empezo: "10am", termino: "12am",                    
                    pg001: "", pg002: "", pg003: "", pg004: "", pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
                    pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
                    pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: "",
                    pg031: "", pg032: "", pg033: "", pg034: "", pg035: "", pg036: "", pg037: "", pg038: "", pg039: "", pg040: "",
                    pg041: "", pg042: "", pg043: "", pg044: "", pg045: "", pg046: "", pg047: "", pg048: "", pg049: "", pg050: "",
                    pg051: "", pg052: "", pg053: "", pg054: "", pg055: "", pg056: "", pg057: "", pg058: "", pg059: "", pg060: "",
                    pg061: "", pg062: "", pg063: "", pg064: "", pg065: "", pg066: "", pg067: "", pg068: "", pg069: "", pg070: "",
                    pg071: "", pg072: "", pg073: "", pg074: "", 
                    pg074b: "", pg074c: "", pg074d: "", pg074e: "", pg074f: "", pg074g: "", pg074h: "", pg074i: "",     
                    pg075: "", pg076: "", pg077: "", pg078: "", pg079: "", pg080: "",
                    pg081: "", pg082: "", pg083: "", pg084: "", pg085: "", pg086: "", pg087: "", pg088: "", pg089: "", pg090: "",
                    pg091: "", pg092: "", pg093: "", pg094: "", pg095: "", pg096: "", pg097: "", pg098: "", pg099: "", pg100: "",
                    pg101: "", pg102: "", pg103: "", pg104: "", pg105: "", pg106: "", pg107: "", pg108: "", pg109: "", pg110: "",
                    pg111: "", pg112: "", pg113: "", pg114: "", pg115: "", pg116: "", pg117: "", pg118: "", pg119: "", pg120: "",
                    pg121: "", pg122: "", pg123: "", pg124: "", pg125: "", pg126: "", pg127: "", pg128: "", pg129: "", pg130: "",
                    pg131: "", pg132: "", pg133: "", pg134: "", pg135: "", pg136: "", pg137: "", pg138: "", pg139: "", pg140: "",
                    pg141: "", pg142: "", pg143: "", pg144: "", pg145: "", pg146: "", pg147: "", pg148: "", pg149: "", pg150: "",
                    pg151: "", pg152: "", pg153: "", pg154: "", pg155: "", pg156: "", pg157: "", pg158: "", pg159: "", pg160: "",
                    pg161: "", pg162: "", pg163: "", pg164: "", pg165: "", pg166: "", pg167: "", pg168: "", pg169: "", pg170: "",
                    pg171: "", pg172: "", pg173: "", pg174: "", pg175: "", pg176: "", pg177: "", pg178: "", pg179: "", pg180: "",
                    pg181: "", pg182: "", pg183: "", pg184: "", pg185: "", pg186: "", pg187: "", pg188: "", pg189: "", pg190: "",
                    pg191: "", pg192: "", pg193: "", pg194: "", pg195: "", pg196: "", pg197: "", pg198: "", pg199: "", pg200: "",
                    pg201: "", pg202: "", pg203: "", pg204: "", pg205: "", pg206: "", pg207: "", pg208: "", pg209: "", pg210: "",
                    pg211: "", pg212: "", pg213: "", pg214: "", pg215: "", pg216: "", pg217: "", pg218: "", pg219: "", pg220: "",
                    pg221: "", pg222: "", pg223: "", pg224: "", pg225: "", pg226: "", pg227: "", pg228: "", pg229: "", pg230: "",
                    pg231: "", pg232: "", pg233: "", pg234: "", pg235: "", pg236: "", pg237: "", pg238: "", pg239: "", pg240: "",
                    pg241: "", pg242: "", pg243: "", pg244: "", pg245: "", pg246: "", pg247: "", pg248: "", pg249: "", pg250: "",
                    pg251: "", pg252: "", pg253: "", pg254: "", pg255: "", pg256: "", pg257: "", pg258: "", pg259: "", pg260: "",
               }

               /* Variables para un nuevo caso */
               // store.state.eval_aedp = this.eval_aedp;
          },
          limpiarEvaluacion2() {


               console.log("LIMPIANDO EVALUACIÓN !!!");

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0,
               };
               
               let tdepto= this.eval_aedp.depto;
               let tnombre= this.eval_aedp.nombre;
               let tempresa= this.eval_aedp.empresa;
               let tfecha= this.eval_fecha;
               let tempezo= this.eval_aedp.empezo;
               let ttermino= this.eval_aedp.termino;

               this.eval_aedp= {};

               this.eval_aedp = {
                    depto: tdepto,
                    empresa: tempresa, nombre: tnombre,
                    fecha: tfecha, sexo: "",
                    empezo: tempezo, termino: ttermino,                    
                    pg001: "", pg002: "", pg003: "", pg004: "", pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
                    pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
                    pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: "",
                    pg031: "", pg032: "", pg033: "", pg034: "", pg035: "", pg036: "", pg037: "", pg038: "", pg039: "", pg040: "",
                    pg041: "", pg042: "", pg043: "", pg044: "", pg045: "", pg046: "", pg047: "", pg048: "", pg049: "", pg050: "",
                    pg051: "", pg052: "", pg053: "", pg054: "", pg055: "", pg056: "", pg057: "", pg058: "", pg059: "", pg060: "",
                    pg061: "", pg062: "", pg063: "", pg064: "", pg065: "", pg066: "", pg067: "", pg068: "", pg069: "", pg070: "",
                    pg071: "", pg072: "", pg073: "", pg074: "", 
                    pg074b: "", pg074c: "", pg074d: "", pg074e: "", pg074f: "", pg074g: "", pg074h: "", pg074i: "",     
                    pg075: "", pg076: "", pg077: "", pg078: "", pg079: "", pg080: "",
                    pg081: "", pg082: "", pg083: "", pg084: "", pg085: "", pg086: "", pg087: "", pg088: "", pg089: "", pg090: "",
                    pg091: "", pg092: "", pg093: "", pg094: "", pg095: "", pg096: "", pg097: "", pg098: "", pg099: "", pg100: "",
                    pg101: "", pg102: "", pg103: "", pg104: "", pg105: "", pg106: "", pg107: "", pg108: "", pg109: "", pg110: "",
                    pg111: "", pg112: "", pg113: "", pg114: "", pg115: "", pg116: "", pg117: "", pg118: "", pg119: "", pg120: "",
                    pg121: "", pg122: "", pg123: "", pg124: "", pg125: "", pg126: "", pg127: "", pg128: "", pg129: "", pg130: "",
                    pg131: "", pg132: "", pg133: "", pg134: "", pg135: "", pg136: "", pg137: "", pg138: "", pg139: "", pg140: "",
                    pg141: "", pg142: "", pg143: "", pg144: "", pg145: "", pg146: "", pg147: "", pg148: "", pg149: "", pg150: "",
                    pg151: "", pg152: "", pg153: "", pg154: "", pg155: "", pg156: "", pg157: "", pg158: "", pg159: "", pg160: "",
                    pg161: "", pg162: "", pg163: "", pg164: "", pg165: "", pg166: "", pg167: "", pg168: "", pg169: "", pg170: "",
                    pg171: "", pg172: "", pg173: "", pg174: "", pg175: "", pg176: "", pg177: "", pg178: "", pg179: "", pg180: "",
                    pg181: "", pg182: "", pg183: "", pg184: "", pg185: "", pg186: "", pg187: "", pg188: "", pg189: "", pg190: "",
                    pg191: "", pg192: "", pg193: "", pg194: "", pg195: "", pg196: "", pg197: "", pg198: "", pg199: "", pg200: "",
                    pg201: "", pg202: "", pg203: "", pg204: "", pg205: "", pg206: "", pg207: "", pg208: "", pg209: "", pg210: "",
                    pg211: "", pg212: "", pg213: "", pg214: "", pg215: "", pg216: "", pg217: "", pg218: "", pg219: "", pg220: "",
                    pg221: "", pg222: "", pg223: "", pg224: "", pg225: "", pg226: "", pg227: "", pg228: "", pg229: "", pg230: "",
                    pg231: "", pg232: "", pg233: "", pg234: "", pg235: "", pg236: "", pg237: "", pg238: "", pg239: "", pg240: "",
                    pg241: "", pg242: "", pg243: "", pg244: "", pg245: "", pg246: "", pg247: "", pg248: "", pg249: "", pg250: "",
                    pg251: "", pg252: "", pg253: "", pg254: "", pg255: "", pg256: "", pg257: "", pg258: "", pg259: "", pg260: "",
               }

               console.log('aedp ? ',this.eval_aedp);
               /* Variables para un nuevo caso */
               // store.state.eval_aedp = this.eval_aedp;
          },          
          //** .................... ACCIONES EN LA BASE DE DATOS  .................... */
          //* Acciones del Floatting Button: Agregar Encuesta */
          agregarEvaluacion() {

               console.log("preguntas sin contestar ? ",this.pregSinContestar)
               if (this.pregSinContestar > 0) {
                    alert("No es posible grabar la Evaluación. \nAún tiene " + this.pregSinContestar + " preguntas sin responder.   ")
                    return
               }

               this.finalizoeval = true;
               this.eval_aedp.termino = this.cargaHora();

               this.eval_fecha = new Date();

               let ldia = this.eval_fecha.getDate();
               if (ldia <= 9) {
                    ldia = '0' + ldia.toString().trim();
               } else {
                    ldia = ldia.toString().trim();
               }
               let lmes = this.eval_fecha.getMonth() + 1;
               if (lmes <= 9) {
                    lmes = '0' + lmes.toString().trim();
               } else {
                    lmes = lmes.toString().trim();
               }
               console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
               let lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();


               console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
               console.log("** fecha de ingreso ? ", this.eval_fecha);
               console.log("** formato  ingreso ? ", lingreso);

               var confirma = confirm("Seguro de grabar la evaluación de SUPERVISION para " + this.eval_aedp.nombre.toUpperCase().trim() + " ?");
               if (confirma === true) {

                    /* Agrega una colección al objeto */
                    var dbEvaluaciones = store.state.st_dbEvalAEDP;
                    dbEvaluaciones.push({

                         empresa: this.eval_aedp.empresa, nombre: this.eval_aedp.nombre,
                         empezo: this.eval_aedp.empezo, termino: this.eval_aedp.termino,
                         fecha: lingreso, depto: this.eval_aedp.depto, sexo: this.eval_aedp.sexo,
                         pg001: this.eval_aedp.pg001, pg002: this.eval_aedp.pg002, pg003: this.eval_aedp.pg003, pg004: this.eval_aedp.pg004, pg005: this.eval_aedp.pg005, 
                         pg006: this.eval_aedp.pg006, pg007: this.eval_aedp.pg007, pg008: this.eval_aedp.pg008, pg009: this.eval_aedp.pg009, pg010: this.eval_aedp.pg010, 
                         pg011: this.eval_aedp.pg011, pg012: this.eval_aedp.pg012, pg013: this.eval_aedp.pg013, pg014: this.eval_aedp.pg014, pg015: this.eval_aedp.pg015,
                         pg016: this.eval_aedp.pg016, pg017: this.eval_aedp.pg017, pg018: this.eval_aedp.pg018, pg019: this.eval_aedp.pg019, pg020: this.eval_aedp.pg020, 
                         pg021: this.eval_aedp.pg021, pg022: this.eval_aedp.pg022, pg023: this.eval_aedp.pg023, pg024: this.eval_aedp.pg024, pg025: this.eval_aedp.pg025, 
                         pg026: this.eval_aedp.pg026, pg027: this.eval_aedp.pg027, pg028: this.eval_aedp.pg028, pg029: this.eval_aedp.pg029, pg030: this.eval_aedp.pg030,
                         pg031: this.eval_aedp.pg031, pg032: this.eval_aedp.pg032, pg033: this.eval_aedp.pg033, pg034: this.eval_aedp.pg034, pg035: this.eval_aedp.pg035,
                         pg036: this.eval_aedp.pg036, pg037: this.eval_aedp.pg037, pg038: this.eval_aedp.pg038, pg039: this.eval_aedp.pg039, pg040: this.eval_aedp.pg040,

                         pg041: this.eval_aedp.pg041, pg042: this.eval_aedp.pg042, pg043: this.eval_aedp.pg043, pg044: this.eval_aedp.pg044, pg045: this.eval_aedp.pg045, 
                         pg046: this.eval_aedp.pg046, pg047: this.eval_aedp.pg047, pg048: this.eval_aedp.pg048, pg049: this.eval_aedp.pg049, pg050: this.eval_aedp.pg050, 
                         pg051: this.eval_aedp.pg051, pg052: this.eval_aedp.pg052, pg053: this.eval_aedp.pg053, pg054: this.eval_aedp.pg054, pg055: this.eval_aedp.pg055,
                         pg056: this.eval_aedp.pg056, pg057: this.eval_aedp.pg057, pg058: this.eval_aedp.pg058, pg059: this.eval_aedp.pg059, pg060: this.eval_aedp.pg060, 
                         pg061: this.eval_aedp.pg061, pg062: this.eval_aedp.pg062, pg063: this.eval_aedp.pg063, pg064: this.eval_aedp.pg064, pg065: this.eval_aedp.pg065, 
                         pg066: this.eval_aedp.pg066, pg067: this.eval_aedp.pg067, pg068: this.eval_aedp.pg068, pg069: this.eval_aedp.pg069, pg070: this.eval_aedp.pg070,
                         pg071: this.eval_aedp.pg071, pg072: this.eval_aedp.pg072, pg073: this.eval_aedp.pg073, pg074: this.eval_aedp.pg074, 
                         pg074b: this.eval_aedp.pg074b, 
                         pg074c: this.eval_aedp.pg074c, pg074d: this.eval_aedp.pg074d, pg074e: this.eval_aedp.pg074e, pg074f: this.eval_aedp.pg074f, 
                         pg074g: this.eval_aedp.pg074g, pg074h: this.eval_aedp.pg074h, pg074i: this.eval_aedp.pg074i, 
                         pg075: this.eval_aedp.pg075,
                         pg076: this.eval_aedp.pg076, pg077: this.eval_aedp.pg077, pg078: this.eval_aedp.pg078, pg079: this.eval_aedp.pg079, pg080: this.eval_aedp.pg080,

                         pg081: this.eval_aedp.pg081, pg082: this.eval_aedp.pg082, pg083: this.eval_aedp.pg083, pg084: this.eval_aedp.pg084, pg085: this.eval_aedp.pg085, 
                         pg086: this.eval_aedp.pg086, pg087: this.eval_aedp.pg087, pg088: this.eval_aedp.pg088, pg089: this.eval_aedp.pg089, pg090: this.eval_aedp.pg090, 
                         pg091: this.eval_aedp.pg091, pg092: this.eval_aedp.pg092, pg093: this.eval_aedp.pg093, pg094: this.eval_aedp.pg094, pg095: this.eval_aedp.pg095,
                         pg096: this.eval_aedp.pg096, pg097: this.eval_aedp.pg097, pg098: this.eval_aedp.pg098, pg099: this.eval_aedp.pg099, pg100: this.eval_aedp.pg100, 
                         pg101: this.eval_aedp.pg101, pg102: this.eval_aedp.pg102, pg103: this.eval_aedp.pg103, pg104: this.eval_aedp.pg104, pg105: this.eval_aedp.pg105, 
                         pg106: this.eval_aedp.pg106, pg107: this.eval_aedp.pg107, pg108: this.eval_aedp.pg108, pg109: this.eval_aedp.pg109, pg110: this.eval_aedp.pg110,
                         pg111: this.eval_aedp.pg111, pg112: this.eval_aedp.pg112, pg113: this.eval_aedp.pg113, pg114: this.eval_aedp.pg114, pg115: this.eval_aedp.pg115,
                         pg116: this.eval_aedp.pg116, pg117: this.eval_aedp.pg117, pg118: this.eval_aedp.pg118, pg119: this.eval_aedp.pg119, pg120: this.eval_aedp.pg120,

                         pg121: this.eval_aedp.pg121, pg122: this.eval_aedp.pg122, pg123: this.eval_aedp.pg123, pg124: this.eval_aedp.pg124, pg125: this.eval_aedp.pg125,
                         pg126: this.eval_aedp.pg126, pg127: this.eval_aedp.pg127, pg128: this.eval_aedp.pg128, pg129: this.eval_aedp.pg129, pg130: this.eval_aedp.pg130,
                         pg131: this.eval_aedp.pg131, pg132: this.eval_aedp.pg132, pg133: this.eval_aedp.pg133, pg134: this.eval_aedp.pg134, pg135: this.eval_aedp.pg135,
                         pg136: this.eval_aedp.pg136, pg137: this.eval_aedp.pg137, pg138: this.eval_aedp.pg138, pg139: this.eval_aedp.pg139, pg140: this.eval_aedp.pg140,
                         pg141: this.eval_aedp.pg141, pg142: this.eval_aedp.pg142, pg143: this.eval_aedp.pg143, pg144: this.eval_aedp.pg144, pg145: this.eval_aedp.pg145,
                         pg146: this.eval_aedp.pg146, pg147: this.eval_aedp.pg147, pg148: this.eval_aedp.pg148, pg149: this.eval_aedp.pg149, pg150: this.eval_aedp.pg150,
                         pg151: this.eval_aedp.pg151, pg152: this.eval_aedp.pg152, pg153: this.eval_aedp.pg153, pg154: this.eval_aedp.pg154, pg155: this.eval_aedp.pg155, 
                         pg156: this.eval_aedp.pg156, pg157: this.eval_aedp.pg157, pg158: this.eval_aedp.pg158, pg159: this.eval_aedp.pg159, pg160: this.eval_aedp.pg160, 

                         pg161: this.eval_aedp.pg161, pg162: this.eval_aedp.pg162, pg163: this.eval_aedp.pg163, pg164: this.eval_aedp.pg164, pg165: this.eval_aedp.pg165,
                         pg166: this.eval_aedp.pg166, pg167: this.eval_aedp.pg167, pg168: this.eval_aedp.pg168, pg169: this.eval_aedp.pg169, pg170: this.eval_aedp.pg170,
                         pg171: this.eval_aedp.pg171, pg172: this.eval_aedp.pg172, pg173: this.eval_aedp.pg173, pg174: this.eval_aedp.pg174, pg175: this.eval_aedp.pg175,
                         pg176: this.eval_aedp.pg176, pg177: this.eval_aedp.pg177, pg178: this.eval_aedp.pg178, pg179: this.eval_aedp.pg179, pg180: this.eval_aedp.pg180,
                         pg181: this.eval_aedp.pg181, pg182: this.eval_aedp.pg182, pg183: this.eval_aedp.pg183, pg184: this.eval_aedp.pg184, pg185: this.eval_aedp.pg185,
                         pg186: this.eval_aedp.pg186, pg187: this.eval_aedp.pg187, pg188: this.eval_aedp.pg188, pg189: this.eval_aedp.pg189, pg190: this.eval_aedp.pg190,
                         pg191: this.eval_aedp.pg191, pg192: this.eval_aedp.pg192, pg193: this.eval_aedp.pg193, pg194: this.eval_aedp.pg194, pg195: this.eval_aedp.pg195,  
                         pg196: this.eval_aedp.pg196, pg197: this.eval_aedp.pg197, pg198: this.eval_aedp.pg198, pg199: this.eval_aedp.pg199, pg200: this.eval_aedp.pg200,

                         pg201: this.eval_aedp.pg201, pg202: this.eval_aedp.pg202, pg203: this.eval_aedp.pg203, pg204: this.eval_aedp.pg204, pg205: this.eval_aedp.pg205,  
                         pg206: this.eval_aedp.pg206, pg207: this.eval_aedp.pg207, pg208: this.eval_aedp.pg208, pg209: this.eval_aedp.pg209, pg210: this.eval_aedp.pg210,
                         pg211: this.eval_aedp.pg211, pg212: this.eval_aedp.pg212, pg213: this.eval_aedp.pg213, pg214: this.eval_aedp.pg214, pg215: this.eval_aedp.pg215,  
                         pg216: this.eval_aedp.pg216, pg217: this.eval_aedp.pg217, pg218: this.eval_aedp.pg218, pg219: this.eval_aedp.pg219, pg220: this.eval_aedp.pg220,

                         pg221: this.eval_aedp.pg221, pg222: this.eval_aedp.pg222, pg223: this.eval_aedp.pg223, pg224: this.eval_aedp.pg224, pg225: this.eval_aedp.pg225,  
                         pg226: this.eval_aedp.pg226, pg227: this.eval_aedp.pg227, pg228: this.eval_aedp.pg228, pg229: this.eval_aedp.pg229, pg230: this.eval_aedp.pg230,
                         pg231: this.eval_aedp.pg231, pg232: this.eval_aedp.pg232, pg233: this.eval_aedp.pg233, pg234: this.eval_aedp.pg234, pg235: this.eval_aedp.pg235,  
                         pg236: this.eval_aedp.pg236, pg237: this.eval_aedp.pg237, pg238: this.eval_aedp.pg238, pg239: this.eval_aedp.pg239, pg240: this.eval_aedp.pg240,
                         pg241: this.eval_aedp.pg241, pg242: this.eval_aedp.pg242, pg243: this.eval_aedp.pg243, pg244: this.eval_aedp.pg244, pg245: this.eval_aedp.pg245,  
                         pg246: this.eval_aedp.pg246, pg247: this.eval_aedp.pg247, pg248: this.eval_aedp.pg248, pg249: this.eval_aedp.pg249, pg250: this.eval_aedp.pg250,
                         pg251: this.eval_aedp.pg251, pg252: this.eval_aedp.pg252, pg253: this.eval_aedp.pg253, pg254: this.eval_aedp.pg254, 


                    }).then((data) => {

                         /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                         this.limpiarEvaluacion();

                         var laClave = data.key;
                         this.grabado = true;
                         this.inicioeval = false;

                         this.cargaEvaluacion();
                         // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                         alert("Evaluación de AEDP guardado con éxito.")
                    });
               } //* if (confirma)
          }, //* agregarEncuesta()

          //? -------------------------------------------------------------------
          enfoqueE(pestana){

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         Vue.nextTick().then(()=> this.$refs.tabul2.focus());

                         this.activo1="!active";
                         this.activo2="active";

                         this.ver1=false;
                         this.ver2=true;
                         break;
                    case 3:
                         Vue.nextTick().then(()=> this.$refs.tabul3.focus());
                         this.activo2="!active";
                         this.activo3="active";

                         this.ver2=false;                         
                         this.ver3=true;
                         break;
                    case 0:
                         Vue.nextTick().then(()=> this.$refs.tabul1.focus());
                         this.activo3="!active";
                         this.activo1="active";

                         this.ver3=false;
                         this.ver1=true;
                    default:                         
                    // code block
               } //* switch
          },

          nadaE(pestana){
               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         Vue.nextTick().then(()=> this.$refs.tabul1.focus());

                         this.activo1="active";
                         this.activo2="!active";

                         this.ver1=true;
                         this.ver2=false;
                         this.ver3=false;
                         break;
                    case 2:
                         Vue.nextTick().then(()=> this.$refs.tabul2.focus());
                         this.activo2="active";
                         this.activo1="!active";

                         this.ver1=false;
                         this.ver2=true;
                         this.ver3=false;
                         break;
                    case 3:
                         Vue.nextTick().then(()=> this.$refs.tabul3.focus());
                         this.activo3="active";
                         this.activo2="!active";

                         this.ver1=false;
                         this.ver2=false;
                         this.ver3=true;
                    default:                         
                    // code block
               } //* switch
          },
          enfoqueRE(pestana){

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         Vue.nextTick().then(()=> this.$refs.tabul2.focus());

                         this.activo3="!active";
                         this.activo2="active";

                         this.ver3=false;
                         this.ver2=true;
                         break;
                    case 1:
                         Vue.nextTick().then(()=> this.$refs.tabul1.focus());
                         this.activo2="!active";
                         this.activo1="active";

                         this.ver2=false;                         
                         this.ver1=true;
                         break;
                    default:                         
                    // code block
               } //* switch
          },

          //? =================================================================================
          enfoqueG1(pestana){

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         Vue.nextTick().then(()=> this.$refs.testtt2.focus());

                         this.activott1="!active";
                         this.activott2="active";

                         this.vertt1=false;
                         this.vertt2=true;
                         break;
                    case 3:
                         Vue.nextTick().then(()=> this.$refs.testtt3.focus());
                         this.activott2="!active";
                         this.activott3="active";

                         this.vertt2=false;                         
                         this.vertt3=true;
                         break;
                    case 4:
                         Vue.nextTick().then(()=> this.$refs.testtt4.focus());
                         this.activott3="!active";
                         this.activott4="active";

                         this.vertt3=false;                         
                         this.vertt4=true;
                         break;
                    case 5:
                         Vue.nextTick().then(()=> this.$refs.testtt5.focus());
                         this.activott4="!active";
                         this.activott5="active";

                         this.vertt4=false;                         
                         this.vertt5=true;
                         break;
                    case 6:
                         Vue.nextTick().then(()=> this.$refs.testtt6.focus());
                         this.activott5="!active";
                         this.activott6="active";

                         this.vertt5=false;                         
                         this.vertt6=true;
                         break;
                    case 7:
                         Vue.nextTick().then(()=> this.$refs.testtt7.focus());
                         this.activott6="!active";
                         this.activott7="active";

                         this.vertt6=false;                         
                         this.vertt7=true;
                         break;
                    case 8:
                         Vue.nextTick().then(()=> this.$refs.testtt8.focus());
                         this.activott9="!active";
                         this.activott8="active";

                         this.vertt7=false;                         
                         this.vertt8=true;
                         break;
                    case 9:
                         Vue.nextTick().then(()=> this.$refs.testtt9.focus());
                         this.activott8="!active";
                         this.activott9="active";

                         this.vertt8=false;                         
                         this.vertt9=true;
                         break;
                    case 10:
                         Vue.nextTick().then(()=> this.$refs.testtt10.focus());
                         this.activott9="!active";
                         this.activott10="active";

                         this.vertt9=false;                         
                         this.vertt10=true;
                         break;   
                    case 0:
                         Vue.nextTick().then(()=> this.$refs.testtt1.focus());
                         this.activott10="!active";
                         this.activott1="active";

                         this.vertt10=false;
                         this.vertt1=true;
                         break;
                    default:                         
                    // code block
               } //* switch
          },
          nadaG1(pestana){
               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         Vue.nextTick().then(()=> this.$refs.testtt1.focus());

                         this.activott1="active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="!active";
                         this.activott5="!active";
                         this.activott6="!active";
                         this.activott7="!active";
                         this.activott8="!active";
                         this.activott9="!active";
                         this.activott10="!active";

                         this.vertt1=true;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=false;
                         this.vertt5=false;
                         this.vertt6=false;
                         this.vertt7=false;
                         this.vertt8=false;
                         this.vertt9=false;
                         this.vertt10=false;

                         break;
                    case 2:
                         Vue.nextTick().then(()=> this.$refs.testtt2.focus());
                         this.activott1="!active";
                         this.activott2="active";
                         this.activott3="!active";
                         this.activott4="!active";
                         this.activott5="!active";
                         this.activott6="!active";
                         this.activott7="!active";
                         this.activott8="!active";
                         this.activott9="!active";
                         this.activott10="!active";

                         this.vertt1=false;
                         this.vertt2=true;
                         this.vertt3=false;
                         this.vertt4=false;
                         this.vertt5=false;
                         this.vertt6=false;
                         this.vertt7=false;
                         this.vertt8=false;
                         this.vertt9=false;
                         this.vertt10=false;

                         break;
                    case 3:
                         Vue.nextTick().then(()=> this.$refs.testtt3.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="active";
                         this.activott4="!active";
                         this.activott5="!active";
                         this.activott6="!active";
                         this.activott7="!active";
                         this.activott8="!active";
                         this.activott9="!active";
                         this.activott10="!active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=true;
                         this.vertt4=false;
                         this.vertt5=false;
                         this.vertt6=false;
                         this.vertt7=false;
                         this.vertt8=false;
                         this.vertt9=false;
                         this.vertt10=false;
                         break;
                    case 4:
                         Vue.nextTick().then(()=> this.$refs.testtt4.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="active";
                         this.activott5="!active";
                         this.activott6="!active";
                         this.activott7="!active";
                         this.activott8="!active";
                         this.activott9="!active";
                         this.activott10="!active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=true;
                         this.vertt5=false;
                         this.vertt6=false;
                         this.vertt7=false;
                         this.vertt8=false;
                         this.vertt9=false;
                         this.vertt10=false;
                         break;
                    case 5:
                         Vue.nextTick().then(()=> this.$refs.testtt5.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="!active";
                         this.activott5="active";
                         this.activott6="!active";
                         this.activott7="!active";
                         this.activott8="!active";
                         this.activott9="!active";
                         this.activott10="!active";


                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=false;
                         this.vertt5=true;
                         this.vertt6=false;
                         this.vertt7=false;
                         this.vertt8=false;
                         this.vertt9=false;
                         this.vertt10=false;
                         break;
                    case 6:
                         Vue.nextTick().then(()=> this.$refs.testtt6.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="!active";
                         this.activott5="!active";
                         this.activott6="active";
                         this.activott7="!active";
                         this.activott8="!active";
                         this.activott9="!active";
                         this.activott10="!active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=false;
                         this.vertt5=false;
                         this.vertt6=true;
                         this.vertt7=false;
                         this.vertt8=false;
                         this.vertt9=false;
                         this.vertt10=false;
                         break;
                    case 7:
                         Vue.nextTick().then(()=> this.$refs.testtt7.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="!active";
                         this.activott5="!active";
                         this.activott6="!active";
                         this.activott7="active";
                         this.activott8="!active";
                         this.activott9="!active";
                         this.activott10="!active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=false;
                         this.vertt5=false;
                         this.vertt6=false;
                         this.vertt7=true;
                         this.vertt8=false;
                         this.vertt9=false;
                         this.vertt10=false;
                         break;
                    case 8:
                         Vue.nextTick().then(()=> this.$refs.testtt8.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="!active";
                         this.activott5="!active";
                         this.activott6="!active";
                         this.activott7="!active";
                         this.activott8="active";
                         this.activott9="!active";
                         this.activott10="!active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=false;
                         this.vertt5=false;
                         this.vertt6=false;
                         this.vertt7=false;
                         this.vertt8=true;
                         this.vertt9=false;
                         this.vertt10=false;
                         break;
                    case 9:
                         Vue.nextTick().then(()=> this.$refs.testtt9.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="!active";
                         this.activott5="!active";
                         this.activott6="!active";
                         this.activott7="!active";
                         this.activott8="!active";
                         this.activott9="active";
                         this.activott10="!active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=false;
                         this.vertt5=false;
                         this.vertt6=false;
                         this.vertt7=false;
                         this.vertt8=false;
                         this.vertt9=true;
                         this.vertt10=false;
                         break;
                    case 10:
                         Vue.nextTick().then(()=> this.$refs.testtt10.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="!active";
                         this.activott5="!active";
                         this.activott6="!active";
                         this.activott7="!active";
                         this.activott8="!active";
                         this.activott9="!active";
                         this.activott10="active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=false;
                         this.vertt5=false;
                         this.vertt6=false;
                         this.vertt7=false;
                         this.vertt8=false;
                         this.vertt9=false;
                         this.vertt10=true;
                         break;
                    default:                         
                    // code block
               } //* switch
          },
          enfoqueRG1(pestana){

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 9: //* Estoy en 10 regreso a 9
                         Vue.nextTick().then(()=> this.$refs.testtt9.focus());

                         this.activott10="!active";
                         this.activott9="active";

                         this.vertt10=false;
                         this.vertt9=true;
                         break;

                    case 8: //* Estoy en 9 regreso a 8
                         Vue.nextTick().then(()=> this.$refs.testtt8.focus());

                         this.activott9="!active";
                         this.activott8="active";

                         this.vertt9=false;
                         this.vertt8=true;
                         break;
                    case 7: //* Estoy en 8 regreso a 7
                         Vue.nextTick().then(()=> this.$refs.testtt7.focus());

                         this.activott8="!active";
                         this.activott7="active";

                         this.vertt8=false;
                         this.vertt7=true;
                         break;
                    case 6: //* Estoy en 7 regreso a 6
                         Vue.nextTick().then(()=> this.$refs.testtt6.focus());

                         this.activott7="!active";
                         this.activott6="active";

                         this.vertt7=false;
                         this.vertt6=true;
                         break;
                    case 5: //* Estoy en 6 regreso a 5
                         Vue.nextTick().then(()=> this.$refs.testtt5.focus());

                         this.activott6="!active";
                         this.activott5="active";

                         this.vertt6=false;
                         this.vertt5=true;
                         break;

                    case 4: //* Estoy en 5 regreso a 4
                         Vue.nextTick().then(()=> this.$refs.testtt4.focus());

                         this.activott5="!active";
                         this.activott4="active";

                         this.vertt5=false;
                         this.vertt4=true;
                         break;
                    case 3: //* Estoy en 4 regreso a 3
                         Vue.nextTick().then(()=> this.$refs.testtt3.focus());

                         this.activott4="!active";
                         this.activott3="active";

                         this.vertt4=false;
                         this.vertt3=true;
                         break;
                    case 2: //* Estoy en 3 regreso a 2
                         Vue.nextTick().then(()=> this.$refs.testtt2.focus());

                         this.activott3="!active";
                         this.activott2="active";

                         this.vertt3=false;
                         this.vertt2=true;
                         break;
                    case 1:   //* Estoy en 2 regreso a 1
                         Vue.nextTick().then(()=> this.$refs.testtt1.focus());
                         this.activott2="!active";
                         this.activott1="active";

                         this.vertt2=false;                         
                         this.vertt1=true;
                         break;
                    default:                         
                    // code block
               } //* switch
          },
          
          //? =================================================================================
          enfoqueG2(pestana){

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         Vue.nextTick().then(()=> this.$refs.testtt12.focus());

                         this.activott11="!active";
                         this.activott12="active";

                         this.vertt11=false;
                         this.vertt12=true;
                         break;
                    case 3:
                         Vue.nextTick().then(()=> this.$refs.testtt13.focus());
                         this.activott12="!active";
                         this.activott13="active";

                         this.vertt12=false;
                         this.vertt13=true;
                         break;
                    case 4:
                         Vue.nextTick().then(()=> this.$refs.testtt14.focus());
                         this.activott13="!active";
                         this.activott14="active";

                         this.vertt13=false;                         
                         this.vertt14=true;
                         break;
                    case 5:
                         Vue.nextTick().then(()=> this.$refs.testtt15.focus());
                         this.activott14="!active";
                         this.activott15="active";

                         this.vertt14=false;                         
                         this.vertt15=true;
                         break;
                    case 6:
                         Vue.nextTick().then(()=> this.$refs.testtt16.focus());
                         this.activott15="!active";
                         this.activott16="active";

                         this.vertt15=false;                         
                         this.vertt16=true;
                         break;
                    case 7:
                         Vue.nextTick().then(()=> this.$refs.testtt17.focus());
                         this.activott16="!active";
                         this.activott17="active";

                         this.vertt16=false;                         
                         this.vertt17=true;
                         break;
                    case 8:
                         Vue.nextTick().then(()=> this.$refs.testtt18.focus());
                         this.activott19="!active";
                         this.activott18="active";

                         this.vertt17=false;                         
                         this.vertt18=true;
                         break;
                    case 9:
                         Vue.nextTick().then(()=> this.$refs.testtt19.focus());
                         this.activott18="!active";
                         this.activott19="active";

                         this.vertt18=false;                         
                         this.vertt19=true;
                         break;
                    case 10:
                         Vue.nextTick().then(()=> this.$refs.testtt20.focus());
                         this.activott19="!active";
                         this.activott20="active";

                         this.vertt19=false;
                         this.vertt20=true;
                         break;   
                    case 11:
                         Vue.nextTick().then(()=> this.$refs.testtt21.focus());
                         this.activott20="!active";
                         this.activott21="active";

                         this.vertt20=false;
                         this.vertt21=true;
                         break;   
     
                    case 0:
                         Vue.nextTick().then(()=> this.$refs.testtt11.focus());
                         this.activott21="!active";
                         this.activott11="active";

                         this.vertt21=false;
                         this.vertt11=true;
                         break;
                    default:                         
                    // code block
               } //* switch
          },
          nadaG2(pestana){
               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         Vue.nextTick().then(()=> this.$refs.testtt11.focus());

                         this.activott11="active";
                         this.activott12="!active";
                         this.activott13="!active";
                         this.activott14="!active";
                         this.activott15="!active";
                         this.activott16="!active";
                         this.activott17="!active";
                         this.activott18="!active";
                         this.activott19="!active";
                         this.activott20="!active";
                         this.activott21="!active";

                         this.vertt11=true;
                         this.vertt12=false;
                         this.vertt13=false;
                         this.vertt14=false;
                         this.vertt15=false;
                         this.vertt16=false;
                         this.vertt17=false;
                         this.vertt18=false;
                         this.vertt19=false;
                         this.vertt20=false;
                         this.vertt21=false;

                         break;
                    case 2:
                         Vue.nextTick().then(()=> this.$refs.testtt12.focus());
                         this.activott11="!active";
                         this.activott12="active";
                         this.activott13="!active";
                         this.activott14="!active";
                         this.activott15="!active";
                         this.activott16="!active";
                         this.activott17="!active";
                         this.activott18="!active";
                         this.activott19="!active";
                         this.activott20="!active";
                         this.activott21="!active";

                         this.vertt11=false;
                         this.vertt12=true;
                         this.vertt13=false;
                         this.vertt14=false;
                         this.vertt15=false;
                         this.vertt16=false;
                         this.vertt17=false;
                         this.vertt18=false;
                         this.vertt19=false;
                         this.vertt20=false;
                         this.vertt21=false;

                         break;
                    case 3:
                         Vue.nextTick().then(()=> this.$refs.testtt13.focus());
                         this.activott11="!active";
                         this.activott12="!active";
                         this.activott13="active";
                         this.activott14="!active";
                         this.activott15="!active";
                         this.activott16="!active";
                         this.activott17="!active";
                         this.activott18="!active";
                         this.activott19="!active";
                         this.activott20="!active";
                         this.activott21="!active";

                         this.vertt11=false;
                         this.vertt12=false;
                         this.vertt13=true;
                         this.vertt14=false;
                         this.vertt15=false;
                         this.vertt16=false;
                         this.vertt17=false;
                         this.vertt18=false;
                         this.vertt19=false;
                         this.vertt20=false;
                         this.vertt21=false;

                         break;
                    case 4:
                         Vue.nextTick().then(()=> this.$refs.testtt14.focus());
                         this.activott11="!active";
                         this.activott12="!active";
                         this.activott13="!active";
                         this.activott14="active";
                         this.activott15="!active";
                         this.activott16="!active";
                         this.activott17="!active";
                         this.activott18="!active";
                         this.activott19="!active";
                         this.activott20="!active";
                         this.activott21="!active";

                         this.vertt11=false;
                         this.vertt12=false;
                         this.vertt13=false;
                         this.vertt14=true;
                         this.vertt15=false;
                         this.vertt16=false;
                         this.vertt17=false;
                         this.vertt18=false;
                         this.vertt19=false;
                         this.vertt20=false;
                         this.vertt21=false;

                         break;
                    case 5:
                         Vue.nextTick().then(()=> this.$refs.testtt15.focus());
                         this.activott11="!active";
                         this.activott12="!active";
                         this.activott13="!active";
                         this.activott14="!active";
                         this.activott15="active";
                         this.activott16="!active";
                         this.activott17="!active";
                         this.activott18="!active";
                         this.activott19="!active";
                         this.activott20="!active";
                         this.activott21="!active";

                         this.vertt11=false;
                         this.vertt12=false;
                         this.vertt13=false;
                         this.vertt14=false;
                         this.vertt15=true;
                         this.vertt16=false;
                         this.vertt17=false;
                         this.vertt18=false;
                         this.vertt19=false;
                         this.vertt20=false;
                         this.vertt21=false;

                         break;
                    case 6:
                         Vue.nextTick().then(()=> this.$refs.testtt16.focus());
                         this.activott11="!active";
                         this.activott12="!active";
                         this.activott13="!active";
                         this.activott14="!active";
                         this.activott15="!active";
                         this.activott16="active";
                         this.activott17="!active";
                         this.activott18="!active";
                         this.activott19="!active";
                         this.activott20="!active";
                         this.activott21="!active";

                         this.vertt11=false;
                         this.vertt12=false;
                         this.vertt13=false;
                         this.vertt14=false;
                         this.vertt15=false;
                         this.vertt16=true;
                         this.vertt17=false;
                         this.vertt18=false;
                         this.vertt19=false;
                         this.vertt20=false;
                         this.vertt21=false;

                         break;
                    case 7:
                         Vue.nextTick().then(()=> this.$refs.testtt17.focus());
                         this.activott11="!active";
                         this.activott12="!active";
                         this.activott13="!active";
                         this.activott14="!active";
                         this.activott15="!active";
                         this.activott16="!active";
                         this.activott17="active";
                         this.activott18="!active";
                         this.activott19="!active";
                         this.activott20="!active";
                         this.activott21="!active";

                         this.vertt11=false;
                         this.vertt12=false;
                         this.vertt13=false;
                         this.vertt14=false;
                         this.vertt15=false;
                         this.vertt16=false;
                         this.vertt17=true;
                         this.vertt18=false;
                         this.vertt19=false;
                         this.vertt20=false;
                         this.vertt21=false;

                         break;
                    case 8:
                         Vue.nextTick().then(()=> this.$refs.testtt18.focus());
                         this.activott11="!active";
                         this.activott12="!active";
                         this.activott13="!active";
                         this.activott14="!active";
                         this.activott15="!active";
                         this.activott16="!active";
                         this.activott17="!active";
                         this.activott18="active";
                         this.activott19="!active";
                         this.activott20="!active";
                         this.activott21="!active";

                         this.vertt11=false;
                         this.vertt12=false;
                         this.vertt13=false;
                         this.vertt14=false;
                         this.vertt15=false;
                         this.vertt16=false;
                         this.vertt17=false;
                         this.vertt18=true;
                         this.vertt19=false;
                         this.vertt20=false;
                         this.vertt21=false;

                         break;
                    case 9:
                         Vue.nextTick().then(()=> this.$refs.testtt19.focus());
                         this.activott11="!active";
                         this.activott12="!active";
                         this.activott13="!active";
                         this.activott14="!active";
                         this.activott15="!active";
                         this.activott16="!active";
                         this.activott17="!active";
                         this.activott18="!active";
                         this.activott19="active";
                         this.activott20="!active";
                         this.activott21="!active";

                         this.vertt11=false;
                         this.vertt12=false;
                         this.vertt13=false;
                         this.vertt14=false;
                         this.vertt15=false;
                         this.vertt16=false;
                         this.vertt17=false;
                         this.vertt18=false;
                         this.vertt19=true;
                         this.vertt20=false;
                         this.vertt21=false;

                         break;
                    case 10:
                         Vue.nextTick().then(()=> this.$refs.testtt20.focus());
                         this.activott11="!active";
                         this.activott12="!active";
                         this.activott13="!active";
                         this.activott14="!active";
                         this.activott15="!active";
                         this.activott16="!active";
                         this.activott17="!active";
                         this.activott18="!active";
                         this.activott19="!active";
                         this.activott20="active";
                         this.activott21="!active";

                         this.vertt11=false;
                         this.vertt12=false;
                         this.vertt13=false;
                         this.vertt14=false;
                         this.vertt15=false;
                         this.vertt16=false;
                         this.vertt17=false;
                         this.vertt18=false;
                         this.vertt19=false;
                         this.vertt20=true;
                         this.vertt21=false;

                         break;
                    case 11:
                         Vue.nextTick().then(()=> this.$refs.testtt21.focus());
                         this.activott11="!active";
                         this.activott12="!active";
                         this.activott13="!active";
                         this.activott14="!active";
                         this.activott15="!active";
                         this.activott16="!active";
                         this.activott17="!active";
                         this.activott18="!active";
                         this.activott19="!active";
                         this.activott20="!active";
                         this.activott21="active";

                         this.vertt11=false;
                         this.vertt12=false;
                         this.vertt13=false;
                         this.vertt14=false;
                         this.vertt15=false;
                         this.vertt16=false;
                         this.vertt17=false;
                         this.vertt18=false;
                         this.vertt19=false;
                         this.vertt20=false;
                         this.vertt21=true;

                         break;
     
                    default:                         
                    // code block
               } //* switch
          },
          enfoqueRG2(pestana){

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 10: //* Estoy en 21 regreso a 20
                         Vue.nextTick().then(()=> this.$refs.testtt20.focus());

                         this.activott21="!active";
                         this.activott20="active";

                         this.vertt21=false;
                         this.vertt20=true;
                         break;

                    case 9: //* Estoy en 20 regreso a 19
                         Vue.nextTick().then(()=> this.$refs.testtt19.focus());

                         this.activott20="!active";
                         this.activott19="active";

                         this.vertt20=false;
                         this.vertt19=true;
                         break;

                    case 8: //* Estoy en 19 regreso a 18
                         Vue.nextTick().then(()=> this.$refs.testtt18.focus());

                         this.activott19="!active";
                         this.activott18="active";

                         this.vertt19=false;
                         this.vertt18=true;
                         break;
                    case 7: //* Estoy en 18 regreso a 17
                         Vue.nextTick().then(()=> this.$refs.testtt17.focus());

                         this.activott18="!active";
                         this.activott17="active";

                         this.vertt18=false;
                         this.vertt17=true;
                         break;
                    case 6: //* Estoy en 17 regreso a 16
                         Vue.nextTick().then(()=> this.$refs.testtt16.focus());

                         this.activott17="!active";
                         this.activott16="active";

                         this.vertt17=false;
                         this.vertt16=true;
                         break;
                    case 5: //* Estoy en 16 regreso a 15
                         Vue.nextTick().then(()=> this.$refs.testtt15.focus());

                         this.activott16="!active";
                         this.activott15="active";

                         this.vertt16=false;
                         this.vertt15=true;
                         break;

                    case 4: //* Estoy en 15 regreso a 14
                         Vue.nextTick().then(()=> this.$refs.testtt14.focus());

                         this.activott15="!active";
                         this.activott14="active";

                         this.vertt15=false;
                         this.vertt14=true;
                         break;
                    case 3: //* Estoy en 14 regreso a 13
                         Vue.nextTick().then(()=> this.$refs.testtt13.focus());

                         this.activott14="!active";
                         this.activott13="active";

                         this.vertt14=false;
                         this.vertt13=true;
                         break;
                    case 2: //* Estoy en 13 regreso a 12
                         Vue.nextTick().then(()=> this.$refs.testtt12.focus());

                         this.activott13="!active";
                         this.activott12="active";

                         this.vertt13=false;
                         this.vertt12=true;
                         break;
                    case 1:   //* Estoy en 12 regreso a 11
                         Vue.nextTick().then(()=> this.$refs.testtt11.focus());
                         this.activott12="!active";
                         this.activott11="active";

                         this.vertt12=false;                         
                         this.vertt11=true;
                         break;
                    default:                         
                    // code block
               } //* switch
          },             
     }, // methods
} // export



// WEBPACK FOOTER //
// ./src/components/ev12_aedp.js